import { render, staticRenderFns } from "./CurrencyList.vue?vue&type=template&id=7156da95&scoped=true&"
import script from "./CurrencyList.vue?vue&type=script&lang=js&"
export * from "./CurrencyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7156da95",
  null
  
)

export default component.exports